export default __webpack_public_path__ + "static/media/2、首页大无糖茶.04a6a3b7.jpg";